import { useEffect, useRef, useState } from 'react'

import useAddVariable from '@/common/hooks/useAddVariable/useAddVariable'
import { shippingMethodDescriptionMaxLength } from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/ShippingMethods/ShippingMethodsDetailConfiguration/constants'
import { getDescriptionRenderedLength } from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/ShippingMethods/ShippingMethodsDetailConfiguration/helpers'
import {
  getDescriptionFromEditorContents,
  getEditorContentsFromDescription,
  getEditorHtml,
} from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/ShippingMethods/ShippingMethodsDetailConfiguration/ShippingMethodDescription/helpers'

const useShippingMethodDescription = ({ description, onChange }) => {
  const onChangeRef = useRef(onChange)
  const lastDescriptionRef = useRef()
  const [editorHtml, setEditorHtml] = useState('')

  const handleChangeEditor = () => {
    const editedDescription = getDescriptionFromEditorContents(editorRef.current.getContents())

    lastDescriptionRef.current = editedDescription
    setEditorHtml(getEditorHtml(editorRef.current))
    onChangeRef.current({ description: editedDescription })
  }

  const { editorRef, onAddVariable } = useAddVariable({ onChange: handleChangeEditor })

  useEffect(() => {
    onChangeRef.current = onChange
  }, [onChange])

  useEffect(() => {
    if (description === lastDescriptionRef.current) return

    lastDescriptionRef.current = description
    editorRef.current.setContents(getEditorContentsFromDescription(description), 'api')
    setEditorHtml(getEditorHtml(editorRef.current))
  }, [description, editorRef])

  const descriptionLength = getDescriptionRenderedLength(description)

  return {
    editorRef,
    editorHtml,
    descriptionLength,
    isTooLong: descriptionLength > shippingMethodDescriptionMaxLength,
    handleChangeEditor,
    handleAddVariable: onAddVariable,
  }
}

export default useShippingMethodDescription
